import * as React from 'react';
import ContentModal from '../components/content-modal';
import Icon from '../../assets/images/nav-globe-icon.svg';
import styled from 'styled-components/native';
import config from './config';
import Partnerships from '../../components/Partnerships';

const Screen = styled(ContentModal)`
  position: absolute;
  top: ${config.modals.top}px;
  right: 15px;
  width: 33vw;
`;

export default function PartnershipsScreen() {
  return (
    <Screen title="Partnerships" icon={Icon}>
      <Partnerships />
    </Screen>
  );
}
